<template>
  <b-navbar toggleable="xl" type="dark" variant="dark" fixed="top">
    <a @click="() => { this.$router.go(-1) }" style="color: #FF0000; cursor: pointer;" class="navbar-brand">&lt;</a>
    <b-navbar-brand :to="{ path: '/browse/assignments' }">
      <b-img src="Logo.jpg" width="35" height="50" class="d-inline-block align-middle"/> 
           T-Time Productions
    </b-navbar-brand>

    <b-navbar-toggle target="nav-collapse" ></b-navbar-toggle> 
    
    <b-collapse id="nav-collapse" is-nav>
      <!--Right aligned nav items-->
      <b-navbar-nav>
        <b-form inline @submit="onSearch" v-if="token && ['Login'].indexOf($route.name) < 0">
          <label class="sr-only " for="inline-form-input-search">{{$t('SEARCH')}}</label>
          <b-input id="inline-form-input-search" class="mb-2 mr-sm-2 mb-sm-0"  v-model="form.search"></b-input>
          <b-button type="submit" variant="primary">{{$t('SEARCH')}}</b-button>
        </b-form>
      </b-navbar-nav>

      
      <!--Not a fan of this but due to they want different bars based off user role and they we're conflicting this gets duplicated 3 times for each one.-->
      <b-navbar-nav class="ml-auto" v-if="IsAdmin && token && ['Login'].indexOf($route.name) < 0 ">
        <b-nav-item v-if="token && ['Login'].indexOf($route.name) < 0" style="line-height: 34px;">
          <font-awesome-icon class="align-middle" icon="fa-bell" /> &nbsp;
          <small class="align-middle" >5 Notifications</small>
        </b-nav-item>

        <b-nav-item style="line-height: 34px;" v-if="IsAdmin && token && ['Login'].indexOf($route.name) < 0" :to="{ path: '/admin'}">{{$t('ADMIN')}}</b-nav-item>
        <b-nav-item style="line-height: 34px;" v-if="IsTeacher && token && ['Login'].indexOf($route.name) < 0" :to="{ path: '/students'}">{{$t('USERS')}}</b-nav-item>
        <b-nav-item style="line-height: 34px;" v-if="IsTeacher && token && ['Login'].indexOf($route.name) < 0" :to="{ path: '/classes'}">{{$t('CLASSES')}}</b-nav-item>

        <b-nav-item-dropdown style="line-height: 34px;" :text="$t('CONTENT')" left v-if="token && ['Login'].indexOf($route.name) < 0">
          <b-dropdown-item :to="{ path: '/browse/assignments' }">{{$t("ASSIGNMENTS")}}</b-dropdown-item>
          <b-dropdown-item :to="{ path: '/browse/books' }">{{$t('LESSONS')}}</b-dropdown-item>
          <b-dropdown-item :to="{ path: '/browse/videos' }">{{$t('VIDEOS')}}</b-dropdown-item>
          <b-dropdown-item :to="{ path: '/browse/audio' }">{{$t('AUDIO')}}</b-dropdown-item>
          <b-dropdown-item :to="{ path: '/browse/interactive' }">{{$t('INTERACTIVE')}}</b-dropdown-item>
          <b-dropdown-item :to="{ path: '/browse/featured' }">{{$t('FEATURED')}}</b-dropdown-item>
          <b-dropdown-item :to="{ path: '/VR' }">{{$t('VR')}}</b-dropdown-item>
          <!--          <b-dropdown-item :to="{ path: '/browse/editors' }">{{$t('EDITORS')}}</b-dropdown-item>-->
        </b-nav-item-dropdown>

        <b-nav-item-dropdown style="line-height: 34px;" v-bind:text="$i18n.locale" right>
          <TTLPLanguageEntry
              v-for="language in languages"
              v-bind:key="language.ID"
              v-bind:ID="language.ID"
          ></TTLPLanguageEntry>
        </b-nav-item-dropdown>

        <b-nav-item-dropdown style="line-height: 34px;" right v-if="token && ['Login'].indexOf($route.name) < 0">
          <!-- Using 'button-content' slot -->
          <template slot="button-content">{{name}}</template>
          <b-dropdown-item>{{name}}</b-dropdown-item>
          <b-dropdown-item @click.prevent="logout();">{{$t('SIGN_OUT')}}</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>

      <!--Teacher nav bar due to different from Admin and user and different display content-->
      <b-navbar-nav class="ml-auto" v-if="IsTeacher && !IsAdmin && token && ['Login'].indexOf($route.name) < 0 ">
        <b-nav-item v-if="token && ['Login'].indexOf($route.name) < 0" style="line-height: 34px;">
          <font-awesome-icon class="align-middle" icon="fa-bell" /> &nbsp;
          <small class="align-middle" >5 Notifications</small>
        </b-nav-item>
        <b-nav-item style="line-height: 34px;" v-if="token && ['Login'].indexOf($route.name) < 0" :to="{ path: '/classes'}">{{$t('CLASSES')}}</b-nav-item>
        <b-nav-item style="line-height: 34px;" v-if="token && ['Login'].indexOf($route.name) < 0" :to="{ path: '/assignments' }">{{$t("CLASS_ASSIGNMENTS")}}</b-nav-item>
        <b-nav-item-dropdown style="line-height: 34px;" :text="$t('CONTENT')" left v-if="token && ['Login'].indexOf($route.name) < 0">
          <b-dropdown-item :to="{ path: '/browse/assignments' }">{{$t("ASSIGNMENTS")}}</b-dropdown-item>
          <b-dropdown-item :to="{ path: '/browse/books' }">{{$t('LESSONS')}}</b-dropdown-item>
          <b-dropdown-item :to="{ path: '/browse/videos' }">{{$t('VIDEOS')}}</b-dropdown-item>
          <b-dropdown-item :to="{ path: '/browse/audio' }">{{$t('AUDIO')}}</b-dropdown-item>
          <b-dropdown-item :to="{ path: '/browse/interactive' }">{{$t('INTERACTIVE')}}</b-dropdown-item>
          <b-dropdown-item :to="{ path: '/browse/featured' }">{{$t('FEATURED')}}</b-dropdown-item>
          <b-dropdown-item :to="{ path: '/VR' }">{{$t('VR')}}</b-dropdown-item>
          <!--          <b-dropdown-item :to="{ path: '/browse/editors' }">{{$t('EDITORS')}}</b-dropdown-item>-->
        </b-nav-item-dropdown>
        <b-nav-item style="line-height: 34px;" v-if="token && ['Login'].indexOf($route.name) < 0" :to="{ path: '/editors'}">{{$t("EDITORS")}}</b-nav-item>
        <b-nav-item-dropdown style="line-height: 34px;" v-bind:text="$i18n.locale" right>
          <TTLPLanguageEntry
              v-for="language in languages"
              v-bind:key="language.ID"
              v-bind:ID="language.ID"
          ></TTLPLanguageEntry>
        </b-nav-item-dropdown>

        <b-nav-item-dropdown style="line-height: 34px;" right v-if="token && ['Login'].indexOf($route.name) < 0">
          <!-- Using 'button-content' slot -->
          <template slot="button-content">{{name}}</template>
          <b-dropdown-item>{{name}}</b-dropdown-item>
          <b-dropdown-item @click.prevent="logout();">{{$t('SIGN_OUT')}}</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
      
      <!--Student User nav bar-->
      <b-navbar-nav class="ml-auto" v-if="!IsTeacher && !IsAdmin && token && ['Login'].indexOf($route.name) < 0">
        <b-nav-item v-if="token && ['Login'].indexOf($route.name) < 0" style="line-height: 34px;">
          <font-awesome-icon class="align-middle" icon="fa-bell" /> &nbsp;
          <small class="align-middle" >5 Notifications</small> 
        </b-nav-item>
        <b-nav-item style="line-height: 34px;" v-if="token && ['Login'].indexOf($route.name) < 0" :to="{ path: '/assignments' }">{{$t("CLASS_ASSIGNMENTS")}}</b-nav-item>
        <b-nav-item-dropdown style="line-height: 34px;" :text="$t('CONTENT')" left v-if="token && ['Login'].indexOf($route.name) < 0">
          <b-dropdown-item :to="{ path: '/browse/assignments' }">{{$t("ASSIGNMENTS")}}</b-dropdown-item>
          <b-dropdown-item :to="{ path: '/browse/books' }">{{$t('LESSONS')}}</b-dropdown-item>
          <b-dropdown-item :to="{ path: '/browse/videos' }">{{$t('VIDEOS')}}</b-dropdown-item>
          <b-dropdown-item :to="{ path: '/browse/audio' }">{{$t('AUDIO')}}</b-dropdown-item>
          <b-dropdown-item :to="{ path: '/browse/interactive' }">{{$t('INTERACTIVE')}}</b-dropdown-item>
          <b-dropdown-item :to="{ path: '/browse/featured' }">{{$t('FEATURED')}}</b-dropdown-item>
          <b-dropdown-item :to="{ path: '/VR' }">{{$t('VR')}}</b-dropdown-item>
          <!--          <b-dropdown-item :to="{ path: '/browse/editors' }">{{$t('EDITORS')}}</b-dropdown-item>-->
        </b-nav-item-dropdown>
        
        <b-nav-item style="line-height: 34px;" v-if="token && ['Login'].indexOf($route.name) < 0" :to="{ path: '/editors'}">{{$t("EDITORS")}}</b-nav-item>
        
        <b-nav-item-dropdown style="line-height: 34px;" v-bind:text="$i18n.locale" right>
          <TTLPLanguageEntry
            v-for="language in languages"
            v-bind:key="language.ID"
            v-bind:ID="language.ID"
          ></TTLPLanguageEntry>
        </b-nav-item-dropdown>

        <b-nav-item-dropdown style="line-height: 34px;" right v-if="token && ['Login'].indexOf($route.name) < 0">
          <!-- Using 'button-content' slot -->
          <template slot="button-content">{{name}}</template>
           <b-dropdown-item>{{name}}</b-dropdown-item> 
          <b-dropdown-item @click.prevent="logout();">{{$t('SIGN_OUT')}}</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>
<script>

import TTLPLanguageEntry from "./LanguageEntry";

export default {
  data: function() {
    return {
      languages: [{ ID: "English" }, { ID: "Español" }, { ID: "Français" }, { ID: "Português" }, { ID: "Italiano" }],
      form: {
        search: ""
      },
      displayName: name,
    };
  },
  props: ["IsAdmin", "IsTeacher", "token", "name"],
  components: {
    TTLPLanguageEntry
  },
  methods: {
    toggleSide: function() {
      //this.$root.$emit("TOGGLE_SIDE", "1");
    },
    onSearch: function(event) {
      event.preventDefault();
      
      this.$router.push('/browse/search?SearchString=' + this.form.search);
    },
    logout: function() {
      this.$bvToast.toast('You have been logged out.', { autoHideDelay: 5000, appendToast: true});
      this.$emit('logout');
      this.$router.push('/');
    }
  }
};
</script>